exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-c0f07820]::-webkit-inner-spin-button,input[data-v-c0f07820]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}", ""]);

// exports
